export default __webpack_public_path__ + "35704b2fcb8ce57765930919c96c20d1.svg";